<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom:10px;" style="margin-bottom: 15px">
      <div class="ele-table-tool">
        <div class="ele-table-tool-title">班级量化考评汇总</div>
      </div>
      <ele-data-table ref="table" :config="table" :data="data" :choose.sync="choose" highlight-current-row height="calc(100vh - 200px)">
        <template>
          <!--          <el-table-column type="selection" width="45" align="center" />-->
          <el-table-column prop="className" label="班级名称" show-overflow-tooltip />
          <el-table-column prop="score" label="分数" show-overflow-tooltip>
            <template #default="{ row }">{{ row.score != 0 ? row.score.toFixed(2) : row.score }}</template>
          </el-table-column>
          <!--          <el-table-column label="操作" align="center">-->
          <!--            <template #default="{ row }">-->
          <!--              <el-link @click="getDetail(row)" icon="el-icon-edit" type="primary" :underline="false">明细</el-link>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </template>
      </ele-data-table>
    </el-card>
    <!--    <el-dialog title="查看明细" :visible.sync="showDetail" width="50%">-->
    <!--      <ele-data-table ref="detailTable" :config="detailTable" height="calc(90vh - 300px)" highlight-current-row>-->
    <!--        <template #default="{ index }">-->
    <!--          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />-->
    <!--          <el-table-column prop="itemName" label="指标名称" sortable="custom" show-overflow-tooltip />-->
    <!--          <el-table-column prop="score" label="指标得分" sortable="custom" show-overflow-tooltip />-->
    <!--          <el-table-column prop="teacherName" label="考评教师" sortable="custom" show-overflow-tooltip />-->
    <!--          <el-table-column prop="createTime" label="考评时间" sortable="custom" show-overflow-tooltip />-->
    <!--        </template>-->
    <!--      </ele-data-table>-->
    <!--    </el-dialog>-->
  </div>
</template>

<script>
  import { getClassQuantizeAggregate } from '@/config/api';
  export default {
    name: 'Index',

    data() {
      return {
        table: {
          page: false,
        },
        data: [],
        choose: [],
        // detailTable: {
        //   // 表格配置
        //   url: '/school/report/getClassAssessReportDetail',
        //   where: { classId: '' },
        //   parseData(res) {
        //     if (res.resCode == 200) res.code = 0;
        //     res.count = res.data.totalCount;
        //     res.data = res.data.mlist;
        //     return res;
        //   },
        // },
        showDetail: false,
      };
    },
    created() {
      this.getData();
    },
    methods: {
      // 获取宿舍考核汇总
      getData() {
        getClassQuantizeAggregate().then((res) => {
          if (res.data.resCode == 200) {
            this.data = res.data.data;
          }
        });
      },
      // getDetail(row) {
      //   this.showDetail = true;
      //   this.detailTable.where.classId = row.id;
      //   this.$refs.detailTable.reload();
      // },
    },
  };
</script>

<style scoped></style>
